import isEmpty from 'lodash/isEmpty';
import type { IFlightUtaPolicyInfo, ILegUTA, UtaProps } from '../../types';
import { specialUtasKeys } from '../../constants/flights';

interface GetSpecialAndOtherUtasType<T extends IFlightUtaPolicyInfo | ILegUTA> {
  specialUtas: T[];
  otherUtas: T[];
}

export const getSpecialAndOtherUtas = <T extends IFlightUtaPolicyInfo | ILegUTA>(
  utas: T[],
): GetSpecialAndOtherUtasType<T> => {
  const specialUtas: T[] = [];
  const otherUtas: T[] = [];

  utas?.forEach((utaPolicy) => {
    const isUtaPolicyAvailable = !isEmpty(utaPolicy);
    if (isUtaPolicyAvailable) {
      const isSpecialUta = specialUtasKeys.includes(utaPolicy?.key as UtaProps);
      if (isSpecialUta) specialUtas.push(utaPolicy);
      else otherUtas.push(utaPolicy);
    }
  });

  return {
    specialUtas,
    otherUtas,
  };
};
